import axios from 'axios';
import { fetchUserSignedUrlPath } from './fetchSignedUrlByFolderV2';
import { decodeBase64ToHtml } from '../hooks/useSanitizeAndEncode';
import { config } from '../constants/config';
import store from '../utils/store';
import { getTextSnippetOverride, selectActiveTextSnippetOverride } from '../slices/charSamplesSlice';

// Your existing function.
export async function fetchContentFromS3Pure(userId, targetUrl) {
  // Extract the target URL from charSpeechData
  if (!targetUrl) {
    return null;
  }

  // Get the signed URL for S3 access.
  const s3TextUrl = await fetchUserSignedUrlPath(userId, targetUrl);
  if (!s3TextUrl) {
    return null;
  }

  try {
    const response = await axios.get(s3TextUrl);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch content from S3:', error);
    throw error;
  }
}

// Utility function to strip HTML tags from a string.
export function stripHTML(htmlString) {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || '';
}

// New exportable function that fetches, decodes, and strips HTML from a text snippet.
export async function fetchDataForTextSnippet(userId, textSnippet) {
  // Check if there's a TextSnippetOverride and use it if available
  if (textSnippet?.textOverride?.textContent) {
    console.log("Using TextSnippetOverride content:", textSnippet.textOverride.textContent);
    return textSnippet.textOverride.textContent;
  }

  // If there is no s3TextUrl, return the existing content (or null)
  if (!textSnippet || !textSnippet.s3TextUrl) {
    return textSnippet?.content || null;
  }

  try {
    // First, check if we need to fetch the TextSnippetOverride from the server
    if (textSnippet.uuid && !textSnippet.textOverride) {
      try {
        // Dispatch the thunk to get the TextSnippetOverride
        const resultAction = await store.dispatch(getTextSnippetOverride({
          userId,
          uuid: textSnippet.uuid
        }));

        // Get the active override from the Redux store
        const state = store.getState();
        const activeOverride = selectActiveTextSnippetOverride(state);

        if (activeOverride) {
          console.log("Using active TextSnippetOverride from Redux store:", activeOverride);
          // If we got an active override, use it and return immediately
          return activeOverride.textContent;
        }
      } catch (overrideError) {
        console.log("No TextSnippetOverride found or error fetching it:", overrideError);
        // Continue with normal flow if no override found
      }
    }

    // Fetch the raw content using the existing function.
    const fetchedContent = await fetchContentFromS3Pure(userId, textSnippet.s3TextUrl);
    // Decode the fetched content.
    let displayText = decodeBase64ToHtml(fetchedContent);
    // Remove any HTML tags.
    displayText = stripHTML(displayText);
    return displayText;
  } catch (error) {
    console.error('Error fetching text snippet:', error);
    // Return fallback content if available.
    return textSnippet?.content || null;
  }
}
